<template>
  <div class="c-carousel" @click="currentQuoteIndex++">
    <transition name="cycle" mode="out-in">
      <h1 class="c-carousel__item" :key="currentQuoteIndex">
        {{ items[currentQuoteIndex] }}
      </h1>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      currentQuoteIndex: 0
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      setInterval(() => {
        if (this.currentQuoteIndex < this.items.length - 1) {
          this.currentQuoteIndex++
        } else {
          this.currentQuoteIndex = 0
        }
      }, 2500)
    })
  }
}
</script>

<style lang="scss">
@import '../assets/styles/variables.scss';

.c-carousel {
  position: relative;
}

.c-carousel__item {
  justify-content: center;
  display: flex;
  flex-direction: column;
  font-size: 3.2rem;
  font-weight: 600;
  height: 16rem;
  line-height: 4rem;
}

.cycle-enter {
  opacity: 0;
  transform: translateX(3.2rem);
}

.cycle-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.cycle-leave {
  opacity: 1;
  transform: translateX(0);
}

.cycle-leave-to {
  opacity: 0;
  transform: translateX(-3.2rem);
}

.cycle-enter-active {
  transition: all 0.5s $ease-in;
}

.cycle-leave-active {
  transition: all 0.5s $ease-out;
}
</style>
